import { render } from "./changeAmount.vue?vue&type=template&id=143171d8"
import script from "./changeAmount.vue?vue&type=script&lang=js"
export * from "./changeAmount.vue?vue&type=script&lang=js"

import exportComponent from "E:\\项目\\5.0版本的老界面\\5.0版本的老界面\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__